import {Routes} from 'constants/routes';

import Icon from 'components/Icon/Icon';
import {useGlobalState} from 'hooks/useGlobalState';
import './Navbar.scss';
import useMediaQuery from 'hooks/useMediaQuery';
import {useNavigate} from 'react-router';
import PageTitleParser from 'utils/helpers/PageTitleParser';

interface Props {
  children?: React.ReactNode;
  toggleSidebar?: () => void;
  showSidebar: boolean;
  backUrl?: string;
}

const Navbar = ({showSidebar, children, toggleSidebar = () => {}, backUrl}: Props) => {
  const navigate = useNavigate();

  const {navigationTitle, user} = useGlobalState((state) => state.app);
  const isAdmin = user?.attributes.admin;

  const isDesktopScreen = useMediaQuery('(max-width: 992px)');

  const shouldShowLogo = !isAdmin && isDesktopScreen;

  return (
    <nav
      className={`navbar ${showSidebar ? 'navbar--active' : ''} ${isAdmin ? 'navbar--admin' : ''} `}
      data-testid="navbar"
    >
      <div className="navbar__container">
        <div className="navbar__title">
          {shouldShowLogo && (
            <div className="navbar__logo">
              <button onClick={() => navigate(Routes.HOME)} title="logo button">
                <Icon icon={isAdmin ? 'logo-alt' : 'logo'} />
              </button>
            </div>
          )}
          {PageTitleParser({pageTitle: navigationTitle, backUrl})}
        </div>
        <div className="navbar__content navbar__content--disabled">
          {children}
          <span className="navbar__toggler" onClick={toggleSidebar} role="button">
            <Icon icon="mobile-menu" />
          </span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
